import { GET_CHECKLIST_POSSESION_LIST, GET_CHECKLIST_EXIST_LIST, INSERT_CHECKLIST_POSSESION_LIST, INSERT_CHECKLIST_EXIST_LIST,SEND_NEW_PI_EXIST_LIST } from "../../utils/constants"


const initialState = [];

function checkListReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_CHECKLIST_POSSESION_LIST:
            return [...state, payload];
        case GET_CHECKLIST_EXIST_LIST:
            return [...state, payload];
        case INSERT_CHECKLIST_POSSESION_LIST:
            return [...state, payload];
        case INSERT_CHECKLIST_EXIST_LIST:
            return [...state, payload];
        case SEND_NEW_PI_EXIST_LIST:
            return [...state, payload];
        default:
            return state;
    }
};

export default checkListReducer;